import React, { useEffect, useMemo, useState } from "react";
import "./GradeLookup.css";

// 擴充 window 接口以包含 Turnstile (TypeScript 環境需要)
declare global {
    interface Window {
        turnstile: {
            render: (
                container: string | HTMLElement, 
                options: {
                    sitekey: string;
                    callback?: (token: string) => void;
                    'error-callback'?: (errorCode: string) => void;
                    'data-action'?: string;
                }
            ) => string;
            // 更多 Turnstile API 函數...
        };
    }
}

const PASS_MARK = 60;
// ⚠️ 請確保這是您的 Cloudflare Turnstile Site Key
const TURNSTILE_SITE_KEY = "0x4AAAAAACFUwNQyndgL178K"; 

const SAMPLE_CSV = `班級,帳號,姓 名,密碼,國文,英文,數學,自然,社會,校排,平均,總分,名次,前次總分,進步幾分
707,qp1140701,王子濬,k1IMp7,92,100,87,96.5,94,27,94,470,1,一段無,470
707,qp1140702,何宥弘,5ZbEbb,78,92,58,90,72,248,78,390,20,一段無,390
707,qp1140703,吳慕祈,9QfdSm,38,20,16,73,44,427,38,191,31,一段無,191
707,qp1140704,呂品澄,e5xQS5,68,89,60,71,60,323,70,348,24,一段無,348
707,qp1140705,李悅誠,IK5zCz,80,97,67,86.5,94,163,85,425,9,一段無,425
707,qp1140706,袁明應,i2Kqpn,52.5,36,29,77,52,411,49,247,29,一段無,247
707,qp1140707,郭承奕,gtc746,86.5,83,55,91,86,223,80,402,18,一段無,402
707,qp1140708,陳紘紳,UNYrVi,89,98,71,82,62,225,80,402,17,一段無,402
707,qp1140709,陳櫂銘,6BKBhK,39,63,56,88.5,58,368,61,305,27,一段無,305
707,qp1140710,彭宥盛,kYuFj9,92,94,92,93.5,90,57,92,462,5,一段無,462
707,qp1140711,曾晨熙,hdJ1s6,68.5,84,61,93.5,76,268,77,383,22,一段無,383
707,qp1140712,董瑞德,dbbjdI,80,95,95,93,86,95,90,449,7,一段無,449
707,qp1140713,詹竤安,OcvzGU,64,85,72,90,78,250,78,389,21,一段無,389
707,qp1140714,劉裕翔,dlHVWd,87,98,65,94.5,76,174,84,421,12,一段無,421
707,qp1140715,潘品叡,HXskLx,45,78,37,51.5,38,409,50,250,28,一段無,250
707,qp1140716,蘇宥鉦,Fc4Dij,83,49,58,91,72,317,71,353,23,一段無,353
707,qp1140721,仲妍霏,u4Mnwj,61,25,29,56.5,44,421,43,216,30,一段無,216
707,qp1140722,沈昕樂,y7AcEq,92,100,87,98,86,52,93,463,4,一段無,463
707,qp1140723,林星吟,eTmoYX,94,92,75,95.5,80,134,87,437,8,一段無,437
707,qp1140724,范佳萱,PlRuGp,92,99,78,100,92,58,92,461,6,一段無,461
707,qp1140725,徐安葳,Tf6vCx,92,98,93,100,82,44,93,465,3,一段無,465
707,qp1140726,浦文珏,GXfduG,88,100,52,97,68,214,81,405,16,一段無,405
707,qp1140727,連雨婕,7XTlxK,85.5,97,86,88.5,66,165,85,423,10,一段無,423
707,qp1140728,陳星言,FUsLvz,85.5,86,60,100,82,189,83,414,14,一段無,414
707,qp1140729,陳儀安,yGhcOS,91,79,78,97,74,180,84,419,13,一段無,419
707,qp1140730,黃詠芊,zVyAY3,83,97,78,85,78,173,84,421,11,一段無,421
707,qp1140731,萬珈寧,IULnEr,84,97,66,89.5,58,238,79,395,19,一段無,395
707,qp1140732,褚維恩,nqPuGL,73,62,43,77.5,56,362,62,312,26,一段無,312
707,qp1140733,劉雨緁,BpkGTO,69,95,52,69,58,328,69,343,25,一段無,343
707,qp1140734,戴芙寧,WPbjNG,92,100,86,97,92,35,93,467,2,一段無,467
707,qp1140735,薛尹柔,km8cuc,88,93,65,93.5,70,204,82,410,15,一段無,410
`;

function parseCSV(text: string) {
  const lines = text.trim().split(/\r?\n/);
  const header = lines[0].split(",").map((h) => h.trim());
  const rows = lines.slice(1).map((line) => {
    const parts = line.split(",").map((p) => p.trim());
    const obj: Record<string, string | number> = {};
    header.forEach((h, i) => {
      obj[h] = parts[i] !== undefined && !isNaN(Number(parts[i])) ? Number(parts[i]) : parts[i];
    });
    return obj;
  });
  return { header, rows };
}

export default function GradeLookup() {
  const [dataRows, setDataRows] = useState<any[]>([]);
  const [headers, setHeaders] = useState<string[]>([]);
  const [loginID, setLoginID] = useState("");
  const [loginPassword, setLoginPassword] = useState("");
  const [loggedIn, setLoggedIn] = useState(false);
  // 🚩 移除 captchaVerified 狀態，改為檢查 DOM 中的 Token
  // const [captchaVerified, setCaptchaVerified] = useState(false); 
  const [currentUser, setCurrentUser] = useState<any>(null);
  const [selectedStudent, setSelectedStudent] = useState<any>(null);

  useEffect(() => {
    const { header, rows } = parseCSV(SAMPLE_CSV);
    setHeaders(header);
    setDataRows(rows);
  }, []);

  // 🚩 新增：手動渲染 Turnstile 的 useEffect
  useEffect(() => {
    // 只有在未登入且全域 turnstile 物件存在時才手動渲染
    if (!loggedIn && window.turnstile) {
      const container = document.getElementById('login-turnstile');
      if (container && container.children.length === 0) { // 檢查是否已渲染
        window.turnstile.render('#login-turnstile', {
          sitekey: TURNSTILE_SITE_KEY,
          // 移除 callback，讓 Turnstile 自己將 token 放在 DOM 中
          // 'callback': (token: any) => console.log('Turnstile verified!'),
          'error-callback': () => console.error("Turnstile failed to load or pass."),
          'data-action': 'user-login' // 安全性強化
        });
      }
    }
  }, [loggedIn, TURNSTILE_SITE_KEY]);


  const handleLogin = () => {
    // 🚩 修正：直接檢查 DOM 中是否存在 Turnstile 隱藏的 Token
    const turnstileResponse = document.querySelector<HTMLInputElement>(
      '#login-turnstile input[name="cf-turnstile-response"]'
    )?.value;

    if (!turnstileResponse) {
      return alert("請完成人機驗證");
    }
    // ⚠️ 實際應用中，您應該將 turnstileResponse 傳送到後端進行驗證！
    
    if (!loginID) return alert("請輸入帳號");
    if (loginID.toLowerCase() === "admin" && loginPassword.toLowerCase() === "teacher") {
      setCurrentUser({ 帳號: "admin" });
      setLoggedIn(true);
      return;
    }
    
    const user = dataRows.find((r) => r.帳號 === loginID);
    if (!user) return alert("找不到帳號");
    if (user.密碼 === loginPassword) {
      setCurrentUser(user);
      setLoggedIn(true);
    } else alert("密碼錯誤");
  };

  const handleLogout = () => {
    setLoggedIn(false);
    setLoginID("");
    setLoginPassword("");
    // 登出時，若需要清除 Turnstile 狀態 (可選)
    // if (window.turnstile) window.turnstile.reset('#login-turnstile'); 
    setCurrentUser(null);
    setSelectedStudent(null);
  };

  // ... (後續 Results, CSV Export, Distribution 邏輯保持不變)
  const results = useMemo(() => {
    if (!loggedIn) return [];
    if (currentUser.帳號 === "admin") return dataRows;
    return [currentUser];
  }, [loggedIn, currentUser, dataRows]);

  const exportCSV = () => {
    const csvContent =
      headers.join(",") +
      "\n" +
      results.map((r) => headers.map((h) => r[h] ?? "").join(",")).join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "查詢結果.csv";
    a.click();
    URL.revokeObjectURL(url);
  };

  const schoolDistribution = useMemo(() => {
    const subjects = ["國文", "英文", "數學", "自然", "社會"];
    const intervals = ["90~100", "80~89", "70~79", "60~69", "0~59"];
    const dist: Record<string, Record<string, number>> = {};
    const total: Record<string, number> = {};
    const sum: Record<string, number> = {};
    const sumSq: Record<string, number> = {};

    subjects.forEach((s) => {
      dist[s] = { "90~100": 0, "80~89": 0, "70~79": 0, "60~69": 0, "0~59": 0 };
      total[s] = dataRows.length;
      sum[s] = 0;
      sumSq[s] = 0;
    });

    dataRows.forEach((r) => {
      subjects.forEach((s) => {
        const val = r[s] ?? 0;
        sum[s] += val;
        sumSq[s] += val * val;
        if (val >= 90) dist[s]["90~100"]++;
        else if (val >= 80) dist[s]["80~89"]++;
        else if (val >= 70) dist[s]["70~79"]++;
        else if (val >= 60) dist[s]["60~69"]++;
        else dist[s]["0~59"]++;
      });
    });

    const avg: Record<string, number> = {};
    const std: Record<string, number> = {};
    subjects.forEach((s) => {
      avg[s] = Number((sum[s] / dataRows.length).toFixed(2));
      
      const N = dataRows.length;
      const mean = sum[s] / N;
      const variance = (sumSq[s] / N) - (mean ** 2);
      std[s] = Number(Math.sqrt(variance).toFixed(2));
    });

    return { intervals, dist, total, avg, std };
  }, [dataRows]);
  
  // 渲染邏輯
  if (!loggedIn) {
    return (
      <div className="grade-login">
        <div className="grade-login-box">
          <h2>成績查詢登入</h2>
          <input placeholder="帳號" value={loginID} onChange={(e) => setLoginID(e.target.value)} />
          <input
            type="password"
            placeholder="密碼"
            value={loginPassword}
            onChange={(e) => setLoginPassword(e.target.value)}
          />
          {/* 🚩 Turnstile 容器：使用 id 供手動渲染 */}
          <div id="login-turnstile" className="cf-turnstile"></div>
          <button onClick={handleLogin}>登入</button>
        </div>
      </div>
    );
  }

  return (
    <div className="grade-container">
      <div className="grade-header">
        <h1>完全免費 — 段考成績查詢系統</h1>
        <div>
          <span>目前使用者：{currentUser.帳號}</span>
          <button onClick={handleLogout}>登出</button>
        </div>
      </div>

      <div className="grade-table-container">
        <table className="grade-table">
          <thead>
            <tr>
              {headers.map((h) => (
                <th key={h}>{h}</th>
              ))}
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            {results.map((r, idx) => (
              <tr key={idx} className={idx % 2 === 0 ? "even" : "odd"}>
                {headers.map((h) => (
                  <td
                    key={h}
                    className={
                      ["國文", "英文", "數學", "自然", "社會", "平均", "總分"].includes(h) && r[h] < PASS_MARK
                        ? "fail"
                        : ""
                    }
                  >
                    {r[h]}
                  </td>
                ))}
                <td>
                  <button onClick={() => setSelectedStudent(r)}>查看</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <button onClick={exportCSV} style={{ marginTop: "10px" }}>
          匯出 CSV
        </button>
      </div>

      {selectedStudent && (
        <div className="grade-detail">
          <h3>
            學生詳情 — {selectedStudent["姓 名"]} ({selectedStudent.帳號})
          </h3>
          <div className="grade-detail-grid">
            {headers.map((h) => (
              <div key={h}>
                <div className="grade-detail-label">{h}</div>
                <div className="grade-detail-value">{selectedStudent[h]}</div>
              </div>
            ))}
          </div>
          <button className="grade-close-btn" onClick={() => setSelectedStudent(null)}>
            關閉
          </button>
        </div>
      )}

      <div className="grade-distribution-container">
        <h2>全校級距表</h2>
        <table className="grade-distribution">
          <thead>
            <tr>
              <th>分數區間</th>
              {["國文", "英文", "數學", "自然", "社會"].map((subj) => (
                <th key={subj}>{subj}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {schoolDistribution.intervals.map((intervalLabel) => (
              <tr key={intervalLabel}>
                <td>{intervalLabel}</td>
                {["國文", "英文", "數學", "自然", "社會"].map((subj) => {
                  const val = schoolDistribution.dist[subj][intervalLabel];
                  let cls = "";
                  if (intervalLabel.startsWith("90")) cls = "high-score";
                  else if (intervalLabel.startsWith("80") || intervalLabel.startsWith("70")) cls = "mid-score";
                  else cls = "low-score";
                  return (
                    <td key={subj} className={cls}>
                      {val}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td>平均值</td>
              {["國文", "英文", "數學", "自然", "社會"].map((subj) => (
                <td key={subj}>{schoolDistribution.avg[subj]}</td>
              ))}
            </tr>
            <tr>
              <td>標準差</td>
              {["國文", "英文", "數學", "自然", "社會"].map((subj) => (
                <td key={subj}>{schoolDistribution.std[subj]}</td>
              ))}
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
}